function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72c0f9",
    d: "M 5.5,0.5 C 5.5,0.166667 5.5,-0.166667 5.5,-0.5C 8.83333,-0.5 12.1667,-0.5 15.5,-0.5C 15.5,0.5 15.5,1.5 15.5,2.5C 13.6208,1.65859 11.6208,1.32526 9.5,1.5C 8.43236,0.565525 7.09903,0.232191 5.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323033",
    d: "M 5.5,0.5 C 7.09903,0.232191 8.43236,0.565525 9.5,1.5C 9.5,1.83333 9.5,2.16667 9.5,2.5C 7.40171,1.0857 6.40171,1.75236 6.5,4.5C 5.66175,4.15829 5.32842,3.49162 5.5,2.5C 5.5,1.83333 5.5,1.16667 5.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48a9f2",
    d: "M -0.5,-0.5 C 1.5,-0.5 3.5,-0.5 5.5,-0.5C 5.5,-0.166667 5.5,0.166667 5.5,0.5C 5.5,1.16667 5.5,1.83333 5.5,2.5C 3.5,2.5 1.5,2.5 -0.5,2.5C -0.5,1.5 -0.5,0.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cd987a",
    d: "M 9.5,2.5 C 9.5,2.83333 9.5,3.16667 9.5,3.5C 8.89022,4.39105 8.55688,5.39105 8.5,6.5C 7.50838,6.67158 6.84171,6.33825 6.5,5.5C 6.5,5.16667 6.5,4.83333 6.5,4.5C 6.40171,1.75236 7.40171,1.0857 9.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#62b7f7",
    d: "M 9.5,1.5 C 11.6208,1.32526 13.6208,1.65859 15.5,2.5C 15.5,3.16667 15.5,3.83333 15.5,4.5C 13.5,4.16667 11.5,3.83333 9.5,3.5C 9.5,3.16667 9.5,2.83333 9.5,2.5C 9.5,2.16667 9.5,1.83333 9.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#54b0f3",
    d: "M 9.5,3.5 C 11.5,3.83333 13.5,4.16667 15.5,4.5C 15.5,5.16667 15.5,5.83333 15.5,6.5C 13.9724,7.80208 12.9724,9.46875 12.5,11.5C 13.2436,8.05044 11.9103,6.38377 8.5,6.5C 8.55688,5.39105 8.89022,4.39105 9.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d80d6",
    d: "M -0.5,2.5 C 1.5,2.5 3.5,2.5 5.5,2.5C 5.32842,3.49162 5.66175,4.15829 6.5,4.5C 6.5,4.83333 6.5,5.16667 6.5,5.5C 5.29208,6.23411 3.95875,6.56745 2.5,6.5C 2.5,7.83333 2.5,9.16667 2.5,10.5C 1.54885,11.9187 1.21552,13.5853 1.5,15.5C 0.833333,15.5 0.166667,15.5 -0.5,15.5C -0.5,11.1667 -0.5,6.83333 -0.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4778b0",
    d: "M 6.5,5.5 C 6.84171,6.33825 7.50838,6.67158 8.5,6.5C 11.9103,6.38377 13.2436,8.05044 12.5,11.5C 10.2181,12.3897 7.88479,12.5564 5.5,12C 4.94979,9.8424 3.94979,9.3424 2.5,10.5C 2.5,9.16667 2.5,7.83333 2.5,6.5C 3.95875,6.56745 5.29208,6.23411 6.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#52aef4",
    d: "M 15.5,6.5 C 15.5,9.5 15.5,12.5 15.5,15.5C 14.5,15.5 13.5,15.5 12.5,15.5C 12.5,14.1667 12.5,12.8333 12.5,11.5C 12.9724,9.46875 13.9724,7.80208 15.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2a078",
    d: "M 12.5,11.5 C 12.5,12.8333 12.5,14.1667 12.5,15.5C 11.1667,15.5 9.83333,15.5 8.5,15.5C 6.73535,14.5386 4.73535,14.2053 2.5,14.5C 2.5,13.1667 2.5,11.8333 2.5,10.5C 3.94979,9.3424 4.94979,9.8424 5.5,12C 7.88479,12.5564 10.2181,12.3897 12.5,11.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#374d73",
    d: "M 2.5,10.5 C 2.5,11.8333 2.5,13.1667 2.5,14.5C 4.73535,14.2053 6.73535,14.5386 8.5,15.5C 6.16667,15.5 3.83333,15.5 1.5,15.5C 1.21552,13.5853 1.54885,11.9187 2.5,10.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagUserIcon);
export default __webpack_public_path__ + "static/media/tag-user-icon.2b809562b64d5fa0a97cf7c3a449e31e.svg";
export { ForwardRef as ReactComponent };